import React from 'react';
import { Router } from './Router';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actions from '@store/actions/index';
import 'bootstrap/dist/css/bootstrap.min.css';

import './App.module.scss';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faUserCircle,
  faFileAlt,
  faSearch,
  faFilter,
  faHome,
  faChevronUp,
  faChevronDown,
  faSpinner,
  faQuestionCircle,
  faTrash,
  faCommentMedical
} from '@fortawesome/free-solid-svg-icons';
import { faCheckSquare, faSquare } from '@fortawesome/free-regular-svg-icons';

library.add(
  faUserCircle,
  faFileAlt,
  faSearch,
  faFilter,
  faHome,
  faChevronUp,
  faChevronDown,
  faSpinner,
  faQuestionCircle,
  faCommentMedical,
  faTrash,
  faCheckSquare,
  faSquare
);

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageWidth: window.innerWidth,
      pageHeight: window.innerHeight
    };
  }

  updateDimensions = () => {
    if (this.state.pageWidth !== window.innerWidth) {
      this.setState({
        pageWidth: window.innerWidth,
        pageHeight: window.innerHeight
      });
    }
  };

  sessionHandle = () => {
    const authData = localStorage.getItem('auth');
    if (authData) {
      const validTo = localStorage.getItem('validTo');
      if (
        validTo === null ||
        parseInt(validTo, 10) < Math.floor(Date.now() / 1000)
      ) {
        this.props.onSessionExpiry();
      } else {
        if (localStorage.getItem('rememberMe') !== null) {
          localStorage.setItem(
            'validTo',
            Math.floor(Date.now() / 1000) + 2592000
          );
        } else {
          localStorage.setItem('validTo', Math.floor(Date.now() / 1000) + 1800);
        }
      }
    }
  };

  componentDidMount = () => {
    this.props.onTryAutoSignup();
    window.addEventListener('resize', this.updateDimensions);
    window.addEventListener('click', this.sessionHandle);

    setInterval(() => {
      this.props.systemCheck();
    }, 60000);
    this.props.systemCheck();
  };

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.updateDimensions);
    window.removeEventListener('click', this.sessionHandle);
  };

  render() {
    const isMobile = window.innerWidth < 992;
    const isMedium = this.state.pageWidth < 1200;

    const authData = localStorage.getItem('auth');
    let isLogged = true;
    if (authData) {
      const validTo = localStorage.getItem('validTo');
      if (
        validTo === null ||
        parseInt(validTo, 10) < Math.floor(Date.now() / 1000)
      ) {
        isLogged = false;
      }
    } else {
      isLogged = false;
    }
    return (
      <Router
        onLogout={this.props.onLogout}
        isMobile={isMobile}
        isMedium={isMedium}
        isLogged={isLogged}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    isLogged: state.auth.token !== null && state.auth.token.length > 0
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onTryAutoSignup: () => dispatch(actions.authCheckState()),
    onLogout: () => dispatch(actions.logout()),
    onSessionExpiry: () => dispatch(actions.logout()),
    systemCheck: () => dispatch(actions.systemCheck())
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(App)
);
